import * as r from "react";
import { c as ce, v as Qe, p as Ze } from "./package-metadata-a152adb8.js";
import { b as U, a as V, c as Be, d as Me } from "./index.es-6889c727.js";
import { K as B } from "./keys-029ad48d.js";
import { d as et, g as Ae, a as tt } from "./auto-scroll-b2de6e53.js";
import { n as _ } from "./noop-d627517c.js";
import { I as Ke } from "./utils-85710523.js";
import { w as nt } from "./index-93802845.js";
import "./index-64063129.js";
import "./index-efd35e77.js";
import "./index-c07310bf.js";
import "react-dom";
var He = function(i, s) {
  var n = r.useContext(i), e = n[0], t = n[1], o = r.useState(s), l = o[0], f = o[1], u = e !== void 0 ? e : l, p = function() {
    for (var c = [], v = 0; v < arguments.length; v++)
      c[v] = arguments[v];
    e !== void 0 ? t.apply(void 0, c) : f(c[0]);
  };
  return [
    u,
    p
  ];
}, rt = r.createContext([
  void 0,
  _
]), at = r.createContext([
  void 0,
  _
]), ot = r.createContext([[], _, _]), it = r.createContext([[], _, _]), lt = 2e3;
function st(i, s, n) {
  n === void 0 && (n = {});
  var e = s.onPress, t = e === void 0 ? _ : e, o = s.onRelease, l = o === void 0 ? _ : o, f = s.onDragStart, u = f === void 0 ? _ : f, p = s.onDrag, c = p === void 0 ? _ : p, v = s.onDragEnd, g = v === void 0 ? _ : v, b = n.hint, C = b === void 0 ? null : b, y = n.mouseOnly, z = y === void 0 ? !1 : y, w = n.autoScroll, h = w === void 0 ? !0 : w, P = n.scrollContainer, E = P === void 0 ? null : P, O = r.useState(!1), S = O[0], L = O[1], k = r.useState(!1), T = k[0], Ve = k[1], X = He(at)[0], fe = He(rt), Y = fe[0], M = fe[1], pe = r.useContext(it)[0], $ = r.useContext(ot), ve = $[0], ge = $[1], de = $[2], A = r.useRef({ x: 0, y: 0 }), F = r.useRef(), W = r.useRef(!1), he = r.useRef(), j = r.useRef(null), q = r.useRef(!1), me = r.useRef({ x: 0, y: 0 }), be = r.useRef({ x: 0, y: 0 }), K = r.useRef({ x: 0, y: 0 }), ye = r.useRef({ x: 0, y: 0 }), Ce = r.useRef({ x: 0, y: 0 }), Se = r.useRef({ x: 0, y: 0 }), Xe = !!(typeof window < "u" && window.PointerEvent), xe = !z && Xe, R = r.useCallback(function() {
    return i.current && i.current.element ? i.current.element : i.current;
  }, [i]), Ye = r.useCallback(function() {
    return C && C.current && C.current.element ? C.current.element : C ? C.current : null;
  }, [C]), Ee = r.useCallback(function() {
    return E && E.current && E.current.element ? E.current.element : E ? E.current : null;
  }, [E]), _e = r.useCallback(function() {
    return typeof h == "object" && h.boundaryElementRef && h.boundaryElementRef.current && h.boundaryElementRef.current.element ? h.boundaryElementRef.current.element : typeof h == "object" && h.boundaryElementRef && h.boundaryElementRef.current ? h.boundaryElementRef.current : null;
  }, [h]), N = r.useRef(null);
  r.useImperativeHandle(N, function() {
    return {
      element: R(),
      hint: Ye(),
      onPress: $e,
      onDragStart: We,
      onDrag: qe,
      onDragEnd: Ge,
      onRelease: Fe,
      data: i.current
    };
  });
  var H = r.useCallback(function() {
    var a = R();
    return a && a.ownerDocument || document;
  }, [R]), I = r.useCallback(function() {
    var a = H();
    return a && a.defaultView || window;
  }, [H]), De = r.useCallback(function() {
    return {
      drag: Y ? Y.current : null,
      drop: X ? X.current : null,
      drags: ve.map(function(a) {
        return a.current;
      }),
      drops: pe.map(function(a) {
        return a.current;
      }),
      pressed: S,
      ignoreMouse: W.current,
      scrollOffset: Ce.current,
      offset: me.current,
      pageOffset: be.current,
      initialScrollOffset: Se.current,
      clientOffset: K.current,
      initialClientOffset: ye.current,
      velocity: A.current,
      autoScroll: !!(typeof h == "object" ? h.enabled !== !1 : h),
      scrollableParent: _e(),
      autoScrollDirection: typeof h == "object" ? h.direction : { horizontal: !0, vertical: !0 },
      isScrolling: T
    };
  }, [Y, X, ve, pe, S, h, _e, T]), Oe = r.useCallback(function(a) {
    L(a);
  }, []), Pe = r.useCallback(function(a) {
    Ve(a);
  }, []), ze = r.useCallback(function(a) {
    A.current = a;
  }, []), ke = r.useCallback(function(a) {
    me.current = a;
  }, []), Re = r.useCallback(function(a) {
    K.current = a;
  }, []), we = r.useCallback(function(a) {
    be.current = a;
  }, []), Te = r.useCallback(function(a) {
    ye.current = a;
  }, []), Le = r.useCallback(function(a) {
    Ce.current = a;
  }, []), Ie = r.useCallback(function(a) {
    Se.current = a;
  }, []), $e = r.useCallback(function(a) {
    t(a);
  }, [t]), Fe = r.useCallback(function(a) {
    l(a);
  }, [l]), We = r.useCallback(function(a) {
    M(N, { target: i.current, event: a }), u(a);
  }, [M, i, u]), qe = r.useCallback(function(a) {
    c(a);
  }, [c]), Ge = r.useCallback(function(a) {
    q.current || (M(null, { target: i.current, event: a }), g(a));
  }, [g, M, i]), d = r.useCallback(function(a) {
    et(De(), { event: a, payload: N.current }, {
      onVelocityChange: ze,
      onOffsetChange: ke,
      onClientOffsetChange: Re,
      onPageOffsetChange: we,
      onInitialClientOffsetChange: Te,
      onScrollOffsetChange: Le,
      onInitialScrollOffsetChange: Ie,
      onIsPressedChange: Oe,
      onIsScrollingChange: Pe
    });
  }, [
    De,
    ze,
    ke,
    we,
    Re,
    Te,
    Ie,
    Oe,
    Le,
    Pe
  ]), G = r.useCallback(function(a) {
    d(a);
  }, [d]), J = r.useCallback(function(a) {
    d(a);
  }, [d]), Q = r.useCallback(function(a) {
    d(a);
  }, [d]), Z = r.useCallback(function(a) {
    d(a);
  }, [d]), ee = r.useCallback(function(a) {
    d(a);
  }, [d]), te = r.useCallback(function(a) {
    d(a);
  }, [d]), ne = r.useCallback(function(a) {
    d(a);
  }, [d]), re = r.useCallback(function(a) {
    a.preventDefault(), d(a);
  }, [d]), ae = r.useCallback(function(a) {
    a.preventDefault(), d(a);
  }, [d]), oe = r.useCallback(function(a) {
    a.preventDefault(), d(a);
  }, [d]), ie = r.useCallback(function(a) {
    if (a.touches.length === 0 && a.changedTouches.length === 1) {
      var m = I();
      W.current = !0, he.current = m.setTimeout(function() {
        W.current = !1;
      }, lt);
    }
    d(a);
  }, [d, I]), le = r.useCallback(function(a) {
    d(a);
  }, [d]), je = r.useCallback(function() {
    var a = R();
    if (a) {
      var m = a.style.touchAction;
      return a.style.touchAction = "none", function() {
        a.style.touchAction = m;
      };
    }
  }, [R]), Ne = r.useCallback(function() {
    return ge(N), function() {
      de(N);
    };
  }, [de, ge]), Je = function() {
    var a = I(), m = R(), D = H();
    return xe ? (m && (j.current = Ae(m), j.current && j.current.addEventListener("scroll", le, { passive: !0 }), m.addEventListener("pointerdown", G, { passive: !0 })), S && (D.addEventListener("pointermove", J), D.addEventListener("pointerup", Z, !0), D.addEventListener("contextmenu", re), D.addEventListener("pointercancel", Q, { passive: !0 }))) : (a.addEventListener("touchmove", _, { capture: !1, passive: !1 }), m && (m.addEventListener("mousedown", ee, { passive: !0 }), z || (m.addEventListener("touchstart", ae, { passive: !0 }), S && (m.addEventListener("touchmove", oe, { passive: !0 }), m.addEventListener("touchend", ie, { passive: !0 })))), S && (D.addEventListener("mousemove", te, { passive: !0 }), D.addEventListener("mouseup", ne, { passive: !0 }))), function() {
      j.current && j.current.removeEventListener("scroll", le), m && (m.removeEventListener("pointerdown", G), m.removeEventListener("mousedown", ee), m.removeEventListener("touchstart", ae), m.removeEventListener("touchmove", oe), m.removeEventListener("touchend", ie)), D.removeEventListener("pointermove", J), D.removeEventListener("pointerup", Z, !0), D.removeEventListener("contextmenu", re), D.removeEventListener("pointercancel", Q), D.removeEventListener("mousemove", te), D.removeEventListener("mouseup", ne), a.removeEventListener("touchmove", _), a.clearTimeout(he.current);
    };
  };
  r.useEffect(function() {
    var a = I();
    if (T) {
      var m = Ee() || Ae(document.elementFromPoint(K.current.x, K.current.y));
      a.clearInterval(F.current), F.current = a.setInterval(function() {
        tt(m, { x: A.current.x, y: A.current.y });
      }, 50);
    }
    return function() {
      a.clearInterval(F.current);
    };
  }, [R, Ee, I, T]), r.useEffect(je, [je]), r.useEffect(Je, [
    S,
    I,
    R,
    H,
    z,
    xe,
    re,
    ee,
    te,
    ne,
    Q,
    G,
    J,
    Z,
    ie,
    oe,
    ae,
    le
  ]), r.useEffect(function() {
    return q.current = !1, function() {
      q.current = !0;
    };
  }, []), r.useLayoutEffect(Ne, [Ne]);
}
var Ue = r.forwardRef(function(i, s) {
  var n = r.useRef(null), e = r.useRef(null), t = r.useCallback(function() {
    return n.current && n.current.element ? n.current.element : n.current;
  }, [n]);
  r.useImperativeHandle(e, function() {
    return { element: t() || null };
  }), r.useImperativeHandle(s, function() {
    return e.current;
  }), r.useImperativeHandle(i.childRef, function() {
    return n.current;
  });
  var o = r.useCallback(function(c) {
    i.onPress && i.onPress({
      element: t(),
      target: e.current,
      event: c
    });
  }, [t, i.onPress]), l = r.useCallback(function(c) {
    i.onRelease && i.onRelease({
      element: t(),
      target: e.current,
      event: c
    });
  }, [t, i.onRelease]), f = r.useCallback(function(c) {
    i.onDragStart && i.onDragStart({
      element: t(),
      target: e.current,
      event: c
    });
  }, [i, t]), u = r.useCallback(function(c) {
    i.onDrag && i.onDrag({
      element: t(),
      target: e.current,
      event: c
    });
  }, [t, i.onDrag]), p = r.useCallback(function(c) {
    i.onDragEnd && i.onDragEnd({
      element: t(),
      target: e.current,
      event: c
    });
  }, [t, i.onDragEnd]);
  return st(n, {
    onPress: o,
    onRelease: l,
    onDragStart: f,
    onDrag: u,
    onDragEnd: p
  }, {
    mouseOnly: i.mouseOnly,
    autoScroll: i.autoScroll,
    hint: i.hint,
    scrollContainer: i.scrollContainer
  }), i.children ? r.cloneElement(r.Children.only(i.children), { ref: n }) : null;
});
Ue.displayName = "KendoReactDraggable";
var ut = globalThis && globalThis.__extends || function() {
  var i = function(s, n) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, i(s, n);
  };
  return function(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    i(s, n);
    function e() {
      this.constructor = s;
    }
    s.prototype = n === null ? Object.create(n) : (e.prototype = n.prototype, new e());
  };
}(), ct = (
  /** @class */
  function(i) {
    ut(s, i);
    function s(n) {
      var e = i.call(this, n) || this;
      return e.draggable = null, e.onDrag = function(t, o, l) {
        var f = t.event, u = e.props, p = u.onDrag, c = u.index, v = e.draggable && e.draggable.element;
        v && !e.isStatic && e.isDraggable && p(f, v, c, o, l);
      }, e.onFocus = function() {
        e.setState({
          focused: !0
        });
      }, e.onBlur = function() {
        e.setState({
          focused: !1
        });
      }, e.onToggle = function(t) {
        var o = e.props, l = o.onToggle, f = o.index, u = o.prev, p = o.next;
        (u.collapsible || p.collapsible) && l(u.collapsible ? f : f + 1, t);
      }, e.onPrevToggle = function(t) {
        var o = e.props, l = o.onToggle, f = o.index, u = o.prev;
        u.collapsible && l(f, t);
      }, e.onNextToggle = function(t) {
        var o = e.props, l = o.onToggle, f = o.index, u = o.next;
        u.collapsible && l(f + 1, t);
      }, e.onKeyDown = function(t) {
        var o = t && t.keyCode, l = e.isHorizontal, f = e.props.index, u = e.draggable && e.draggable.element, p = function(c, v, g) {
          t.preventDefault(), e.props.onKeyboardResize(c, v, g, t);
        };
        u && (o === B.enter ? (t.preventDefault(), e.onToggle(t)) : e.isDraggable && (l && o === B.left ? p(u, f, -10) : l && o === B.right ? p(u, f, 10) : !l && o === B.up ? p(u, f, -10) : !l && o === B.down && p(u, f, 10)));
      }, e.state = {
        focused: !1
      }, e;
    }
    return Object.defineProperty(s.prototype, "isStatic", {
      get: function() {
        var n = this.props, e = n.prev, t = n.next, o = e.resizable && t.resizable, l = e.collapsible || t.collapsible;
        return !o && !l;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "isDraggable", {
      get: function() {
        var n = this.props, e = n.prev, t = n.next, o = e.resizable && t.resizable, l = e.collapsed || t.collapsed;
        return !!o && !l;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "isHorizontal", {
      get: function() {
        return this.props.orientation === "horizontal";
      },
      enumerable: !1,
      configurable: !0
    }), s.prototype.render = function() {
      var n, e = this, t = this.isDraggable, o = this.isStatic, l = this.isHorizontal, f = ce("k-splitbar", (n = {}, n["k-focus"] = this.state.focused, n["k-splitbar-horizontal"] = l, n["k-splitbar-vertical"] = !l, n["k-splitbar-draggable-horizontal"] = l && t, n["k-splitbar-draggable-vertical"] = !l && t, n["k-splitbar-static-horizontal"] = l && o, n["k-splitbar-static-vertical"] = !l && o, n));
      return r.createElement(
        Ue,
        { onPress: function(u) {
          return e.onDrag(u, !0, !1);
        }, onDrag: function(u) {
          return e.onDrag(u, !1, !1);
        }, onRelease: function(u) {
          return e.onDrag(u, !1, !0);
        }, ref: function(u) {
          e.draggable = u;
        } },
        r.createElement(
          "div",
          { tabIndex: o ? -1 : 0, role: "separator", "aria-valuenow": 0, "aria-label": this.props.ariaLabel, "aria-orientation": l ? "vertical" : void 0, className: f, style: { touchAction: "none" }, onFocus: this.onFocus, onBlur: this.onBlur, onDoubleClick: this.onToggle, onKeyDown: this.onKeyDown },
          this.props.prev.collapsible && r.createElement(
            "div",
            { className: "k-collapse-prev", onClick: this.onPrevToggle },
            r.createElement(Ke, { name: this.props.prev.collapsible ? l ? this.props.prev.collapsed ? this.props.isRtl ? "caret-alt-left" : "caret-alt-right" : this.props.isRtl ? "caret-alt-right" : "caret-alt-left" : this.props.prev.collapsed ? "caret-alt-down" : "caret-alt-up" : void 0, icon: this.props.prev.collapsible ? l ? this.props.prev.collapsed ? this.props.isRtl ? U : V : this.props.isRtl ? V : U : this.props.prev.collapsed ? Be : Me : void 0, size: "xsmall" })
          ),
          r.createElement("div", { className: "k-resize-handle" }),
          this.props.next.collapsible && r.createElement(
            "div",
            { className: "k-collapse-next", onClick: this.onNextToggle },
            r.createElement(Ke, { name: this.props.next.collapsible ? l ? this.props.next.collapsed ? this.props.isRtl ? "caret-alt-right" : "caret-alt-left" : this.props.isRtl ? "caret-alt-left" : "caret-alt-right" : this.props.next.collapsed ? "caret-alt-up" : "caret-alt-down" : void 0, icon: this.props.next.collapsible ? l ? this.props.next.collapsed ? this.props.isRtl ? V : U : this.props.isRtl ? U : V : this.props.next.collapsed ? Me : Be : void 0, size: "xsmall" })
          )
        )
      );
    }, s;
  }(r.Component)
), ft = globalThis && globalThis.__extends || function() {
  var i = function(s, n) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, i(s, n);
  };
  return function(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    i(s, n);
    function e() {
      this.constructor = s;
    }
    s.prototype = n === null ? Object.create(n) : (e.prototype = n.prototype, new e());
  };
}(), pt = (
  /** @class */
  function(i) {
    ft(s, i);
    function s() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return s.prototype.render = function() {
      var n, e = this.props, t = e.id, o = e.size, l = e.collapsed, f = e.overlay, u = e.containsSplitter, p = e.collapsible, c = e.resizable, v = e.scrollable, g = e.keepMounted, b = o && o.length > 0, C = {
        flexBasis: o
      }, y = ce("k-pane", (n = {}, n["k-hidden"] = l, n.hidden = l, n["k-pane-flex"] = u, n["k-pane-static"] = !c && !p || b, n["k-scrollable"] = v, n));
      return r.createElement(
        "div",
        { id: t, role: "group", style: C, className: y },
        !l || g ? this.props.children : void 0,
        f ? r.createElement("div", { className: "k-splitter-overlay k-overlay" }) : void 0
      );
    }, s;
  }(r.Component)
), se, ue = "splitBarLabel", vt = (se = {}, se[ue] = "split bar", se), gt = globalThis && globalThis.__extends || function() {
  var i = function(s, n) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, i(s, n);
  };
  return function(s, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    i(s, n);
    function e() {
      this.constructor = s;
    }
    s.prototype = n === null ? Object.create(n) : (e.prototype = n.prototype, new e());
  };
}(), x = globalThis && globalThis.__assign || function() {
  return x = Object.assign || function(i) {
    for (var s, n = 1, e = arguments.length; n < e; n++) {
      s = arguments[n];
      for (var t in s)
        Object.prototype.hasOwnProperty.call(s, t) && (i[t] = s[t]);
    }
    return i;
  }, x.apply(this, arguments);
}, dt = globalThis && globalThis.__rest || function(i, s) {
  var n = {};
  for (var e in i)
    Object.prototype.hasOwnProperty.call(i, e) && s.indexOf(e) < 0 && (n[e] = i[e]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function")
    for (var t = 0, e = Object.getOwnPropertySymbols(i); t < e.length; t++)
      s.indexOf(e[t]) < 0 && Object.prototype.propertyIsEnumerable.call(i, e[t]) && (n[e[t]] = i[e[t]]);
  return n;
}, ht = {
  collapsible: !1,
  collapsed: !1,
  resizable: !0,
  scrollable: !0
}, mt = 150, bt = (
  /** @class */
  function(i) {
    gt(s, i);
    function s(n) {
      var e = i.call(this, n) || this;
      return e._container = null, e.validatePanes = function(t) {
        var o = t.filter(function(l) {
          return l.size === void 0;
        });
        if (!o.length)
          throw new Error("The Splitter should have at least one pane without a set size.");
      }, e.mapPaneOptions = function(t, o) {
        for (var l = e.orientation, f = e.state, u = f.dragIndex, p = f.isDragging, c = [], v = 0; v < o.length; v++) {
          var g = !1, b = o[v];
          r.isValidElement(b) && (g = b.type.displayName === "Splitter");
          var C = !1;
          p && u !== void 0 && (C = u === v || u + 1 === v), c.push(x(x(x({}, ht), { orientation: l, containsSplitter: g, overlay: C }), (t || [])[v]));
        }
        return c;
      }, e.mapSplitterPanes = function(t, o) {
        var l = nt(e).toLanguageString(ue, vt[ue]);
        return t.map(function(f, u) {
          var p, c = u * 2, v = c + 1;
          if (u + 1 < t.length) {
            var g = t[u + 1];
            p = r.createElement(ct, { key: v, index: u, orientation: f.orientation, prev: f, next: g, ariaLabel: l, onDrag: e.onBarDragResize, onToggle: e.onBarToggle, onKeyboardResize: e.onBarKeyboardResize, isRtl: e.isRtl });
          }
          var b = r.createElement(pt, x({ key: c }, f), o[u]);
          return [b, p];
        });
      }, e.onBarToggle = function(t, o) {
        var l = e.panesOptions(e.panesContent), f = l.map(function(u, p) {
          var c = e.getPaneProps(u);
          return p === t ? x(x({}, c), { collapsed: !u.collapsed }) : x({}, c);
        });
        e.props.onChange && e.props.onChange({
          newState: f,
          isLast: !0,
          nativeEvent: o
        });
      }, e.onBarDragResize = function(t, o, l, f, u) {
        var p = (/* @__PURE__ */ new Date()).getTime(), c = t.pageX, v = t.pageY, g = e.surroudingPanes(o), b = g.prevElement, C = g.nextElement;
        if (!(!b || !C)) {
          if (f) {
            e.setState({
              isDragging: !0,
              dragIndex: l,
              startTime: p,
              originalX: c,
              originalY: v,
              originalPrevSize: e.elementSize(b),
              originalNextSize: e.elementSize(C)
            });
            return;
          }
          var y = e.state, z = y.originalPrevSize, w = y.originalNextSize, h = y.startTime, P = y.originalX, E = y.originalY;
          if (!f && p - h < mt) {
            u && e.resetDragState();
            return;
          }
          var O;
          e.orientation === "vertical" ? O = v - E : e.isRtl ? O = P - c : O = c - P, e.resize(l, l + 1, z, w, O, u, t), u && e.resetDragState();
        }
      }, e.onBarKeyboardResize = function(t, o, l, f) {
        var u = e.surroudingPanes(t), p = u.prevElement, c = u.nextElement, v = e.elementSize(p), g = e.elementSize(c);
        e.resize(o, o + 1, v, g, l, !0, f);
      }, e.containerSize = function() {
        return e._container ? e.elementSize(e._container, !0) : 0;
      }, e.panesOptions = function(t) {
        return e.mapPaneOptions(e.panes, t);
      }, e.elementSize = function(t, o) {
        var l = o ? "client" : "offset";
        return e.orientation === "vertical" ? t["".concat(l, "Height")] : t["".concat(l, "Width")];
      }, e.clamp = function(t, o, l) {
        return Math.min(o, Math.max(t, l));
      }, e.fixedSize = function(t) {
        return t && t.length > 0;
      }, Qe(Ze), e.state = {
        isDragging: !1,
        dragIndex: void 0,
        startTime: 0,
        originalX: 0,
        originalY: 0,
        originalPrevSize: 0,
        originalNextSize: 0,
        panes: n.defaultPanes || []
      }, e;
    }
    return Object.defineProperty(s.prototype, "isControlledState", {
      get: function() {
        return this.props.panes !== void 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "panes", {
      get: function() {
        return this.panesDuringOnChange !== void 0 ? this.panesDuringOnChange : this.isControlledState ? this.props.panes : this.state.panes;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "orientation", {
      get: function() {
        return this.props.orientation || "horizontal";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "isRtl", {
      get: function() {
        return this._container && getComputedStyle(this._container).direction === "rtl" || !1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "panesContent", {
      get: function() {
        return r.Children.toArray(this.props.children).filter(function(n) {
          return n;
        });
      },
      enumerable: !1,
      configurable: !0
    }), s.prototype.render = function() {
      var n = this, e = this.panesContent, t = this.panesOptions(e), o = ce("k-widget", "k-splitter", "k-splitter-flex", "k-splitter-".concat(this.orientation), this.props.className);
      return this.validatePanes(t), r.createElement("div", { style: this.props.style, ref: function(l) {
        return n._container = l;
      }, className: o }, this.mapSplitterPanes(t, e));
    }, s.prototype.surroudingPanes = function(n) {
      return {
        prevElement: n.previousElementSibling,
        nextElement: n.nextElementSibling
      };
    }, s.prototype.isPercent = function(n) {
      return /%$/.test(n);
    }, s.prototype.toPixels = function(n, e) {
      var t = parseInt(n, 10);
      return this.isPercent(n) && (t = e * t / 100), t;
    }, s.prototype.resetDragState = function() {
      this.setState({
        isDragging: !1,
        dragIndex: void 0,
        startTime: 0,
        originalX: 0,
        originalY: 0,
        originalPrevSize: 0,
        originalNextSize: 0
      });
    }, s.prototype.resize = function(n, e, t, o, l, f, u) {
      var p = this, c = this.panesOptions(this.panesContent), v = c[n], g = c[e], b = t + o, C = this.containerSize(), y = function(S) {
        return p.toPixels(S, C);
      }, z = {
        index: n,
        initialSize: t,
        min: y(v.min) || b - y(g.max) || 0,
        max: y(v.max) || b - y(g.min) || b
      }, w = {
        index: e,
        initialSize: o,
        min: y(g.min) || b - y(v.max) || 0,
        max: y(g.max) || b - y(v.min) || b
      }, h = function(S, L) {
        var k = c[S.index], T = p.clamp(S.min, S.max, S.initialSize + L);
        return p.isPercent(k.size || "") ? 100 * T / C + "%" : T + "px";
      }, P, E;
      this.fixedSize(v.size) && this.fixedSize(g.size) ? (P = h(z, l), E = h(w, -l)) : g.collapsible || this.fixedSize(g.size) ? E = h(w, -l) : P = h(z, l);
      var O = c.map(function(S, L) {
        var k = p.getPaneProps(S);
        return L === n ? x(x({}, k), { size: P }) : L === e ? x(x({}, k), { size: E }) : x({}, k);
      });
      this.panesDuringOnChange = O, this.isControlledState || this.setState({
        panes: O
      }), this.props.onChange && this.props.onChange({
        newState: O,
        isLast: f,
        nativeEvent: u
      }), this.panesDuringOnChange = void 0;
    }, s.prototype.getPaneProps = function(n) {
      n.orientation, n.overlay, n.containsSplitter;
      var e = dt(n, ["orientation", "overlay", "containsSplitter"]);
      return e;
    }, s.displayName = "Splitter", s;
  }(r.Component)
);
const Rt = bt;
export {
  Rt as Splitter
};
